import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, TextField, Button, Paper, Alert } from '@mui/material';

const QRCodeScanner = () => {
  const [qrCode, setQrCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!qrCode) {
      setError('Please enter a QR code');
      return;
    }

    try {
      // Remove any whitespace from QR code
      const cleanQrCode = qrCode.trim();
      console.log('Processing QR code:', cleanQrCode);
      
      // Navigate to the memorial QR page
      navigate(`/memorial/qr/${cleanQrCode}`);
    } catch (err) {
      console.error('Error processing QR code:', err);
      setError('Error processing QR code');
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4, p: 2 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Scan Memorial QR Code
        </Typography>
        
        <Typography paragraph>
          Enter the QR code to view a memorial
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            fullWidth
            label="QR Code"
            value={qrCode}
            onChange={(e) => setQrCode(e.target.value)}
            margin="normal"
            required
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            View Memorial
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default QRCodeScanner;